import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DragVerticalIcon } from '@ui/assets/custom-icons/drag-vertical-icon';
import { useTranslation } from 'react-i18next';
import { Iconly } from 'react-iconly';
const CategoryRowItem = ({ name, questionCount, selected = false, onClick, onDelete, dragHandleProps }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isBelowLg = useMediaQuery(theme.breakpoints.down('lg'));
    return (_jsxs(Box, { onClick: onClick, sx: {
            display: 'flex',
            gap: 0.5,
            padding: '12px 0px 12px 48px',
            position: 'relative',
            borderLeft: selected ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
            cursor: 'pointer',
            '& .category-delete-action': {
                opacity: 0,
                visibility: 'hidden'
            },
            '&:hover .category-delete-action': {
                opacity: 1,
                visibility: 'visible'
            }
        }, children: [_jsx(Box, { sx: {
                    position: 'absolute',
                    left: 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'grab',
                    touchAction: 'none'
                }, ...dragHandleProps, children: _jsx(DragVerticalIcon, {}) }), _jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', children: [_jsxs(Box, { display: 'flex', gap: 0.5, flexDirection: 'column', children: [_jsx(Typography, { variant: 'subtitle1', fontWeight: selected ? 500 : 400, children: name }), _jsx(Typography, { variant: 'body2', color: theme.palette.common.grey.dark, children: t('events.eventDetails.faqTab.questionCount', { count: questionCount }) })] }), _jsx(IconButton, { color: 'error', className: isBelowLg ? '' : 'category-delete-action', onClick: (event) => {
                            event.stopPropagation();
                            onDelete?.();
                        }, children: _jsx(Iconly, { name: 'Delete', set: 'curved' }) })] })] }));
};
export default CategoryRowItem;
